const KEY = 'auth';

export const LOGOUT = `${KEY}/LOGOUT`;
export const AUTH = `${KEY}/AUTH`;
export const AUTH_SUCCESS = `${KEY}/AUTH_SUCCESS`;
export const AUTH_ERROR = `${KEY}/AUTH_ERROR`;
export const SET_TOKEN = `${KEY}/SET_TOKEN`;



// WEBPACK FOOTER //
// ./app/web/src/container/LoginPage/constants.js